module.exports = __webpack_public_path__ + "static/img/1958_09_25_DieWelt.db73571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_09_25_DieWelt.jpg
// module id = PAGm
// module chunks = 0